import { Component, inject, input } from "@angular/core";
import { SubItemMenu } from "@app/layouts/nav-bar/nav-bar.service";
import { NgClass } from "@angular/common";
import { RouterLink, RouterLinkActive } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { PermissionsService } from "@app/core/services";
import { isArray } from "lodash-es";

@Component({
  selector: "app-sub-list-nav-bar",
  standalone: true,
  imports: [NgClass, RouterLinkActive, RouterLink, TranslateModule],
  templateUrl: "./sub-list-nav-bar.component.html",
  styleUrl: "./sub-list-nav-bar.component.scss",
})
export class SubListNavBarComponent {
  public readonly subItems = input<SubItemMenu[]>();
  public readonly expanded = input.required<boolean>();

  private readonly permissionService = inject(PermissionsService);

  protected isVisible(visible: string | string[] | boolean): boolean {
    return this.hasPermission(visible);
  }

  private hasPermission(permission: string | string[] | boolean): boolean {
    if (typeof permission === "boolean") return permission;
    if (isArray(permission))
      return permission.some((p) => {
        return this.permissionService.has(p);
      });
    return this.permissionService.hasNav(permission);
  }
}
